import * as actions from '../utils/Constants';
import { getSessions } from './Sessions';

const api = `${process.env.REACT_APP_API_HOST}api/session/`;

export const newSession = () => {
    return {
        type: actions.NEW_SESSION
    }
}

export const updateSession = (field, value) => {
    return {
        type: actions.UPDATE_SESSION,
        payload: { field, value }
    }
}

//This is an example of chaining promises together synchronously. Save the session then refresh the session list.
export const saveSession = (session) => {
    return dispatch => dispatch({
        type: actions.SAVE_SESSION,
        payload: fetch(api, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(session)
        }).then(res => {
            dispatch(getSessions());
            return res.json();
        }
        )
    })
}
